module.exports = "/_next/static/images/1-5f3101686bb6e67f071835198921734b.jpg";